// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import StyledSelect from "./styledSelect";
import Select from "react-select";
import { AssetType } from "../../../../models/applicationState";
import { getPrimaryRedTheme } from "../../../../common/themes";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import Confirm from "../../common/confirm/confirm";
import ServiceHelper from "../../../../services/serviceHelper";
import OperationsHeader from "../header/operationsSubHeader";
import JsonViewer from "../testUploadFiles/jsonResponse";
import ReactJson from "react-json-view";
import { IAzureFields } from "../../../../models/applicationState";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import { constants } from "../../../../common/constants";
import { processedFileEndPoint, LoadUserFilesEndPointBasedOnModel, headers, fileUploadEndPoint, accessToken } from "../../../../common/api-config";
import { parseTiffData, renderTiffToCanvas, loadImageToCanvas } from "../../../../common/utils";
import { ImageMap } from "../../common/imageMap/imageMap";
import HeaderComponent from "../header/header";
import { IAuthenticationState, IApplicationState } from "../../../../models/applicationState";
import HtmlFileReader from "../../../../common/htmlFileReader";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
//import pdfjsLib from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import Fill from "ol/style/Fill";
import PowerbiEmbedded from 'react-powerbi';
//import Iframe from 'react-iframe';
//import { PowerBIEmbed } from 'powerbi-client-react';


const cMapUrl = constants.pdfjsCMapUrl(pdfjsLib.version);

export interface IBatchProcessProps extends RouteComponentProps, React.Props<batchProcesspb> {
    loggedInUser: IAuthenticationState;
    userModelActions: IUserModelActions;
    userOperationsActions: IUserOperationsActions;
}

function mapDispatchToProps(dispatch) {
    return {
        userModelActions: bindActionCreators(userModelActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
    };
}

export interface IBatchProcessState {
    batchProcess: any;
    loadingProjects: boolean;
    loadingQueueFiles: boolean;
    projectList: any;
    selectedQueue: any;
    filesList: any;
    loaderMessage: string;
    errorMessage: any;
    fileNames: any;
    batchProcessFlag: boolean;
    selectedProject: any;
    analyzeResult: any;
    projectName: string;
    loadingQueues: boolean;
    queuesList: any;
    loadingJson: boolean;
    queueName: string;
    fileName: string;
    imageUri: string;
    imageWidth: number;
    imageHeight: number;
    currentPage: number;
    numPages: number;
    pdfFile: any;
    loadingFile: boolean;
    tiffImages: any[];
    isEditJson: boolean,
    changedJSON: any,
    isBool: boolean,
    expandString: boolean;
    errorList: any;
    errFiles: any;
    healthQueueList: any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class batchProcesspb

    extends React.Component<IBatchProcessProps, IBatchProcessState> {

    public static getDerivedStateFromProps(nextProps, prevState) {
        const state = Object.assign({}, prevState);
        if (!state.projectName) {
            // state.projectName = localStorage.getItem("project_name");
            // state.queueName = localStorage.getItem("queue_name");
        }
        return state;
    }

    public state: IBatchProcessState = {
        batchProcess: {},
        projectName: "Health-queue",
        projectList: [],
        filesList: [],
        analyzeResult: null,
        errorMessage: null,
        fileNames: [],
        loadingJson: false,
        batchProcessFlag: false,
        loadingQueues: false,
        selectedProject: null,
        loaderMessage: "Loading Models",
        queuesList: [],
        selectedQueue: null,
        queueName: "",
        loadingProjects: false,
        loadingQueueFiles: false,
        fileName: "",
        imageUri: null,
        imageWidth: 0,
        currentPage: 1,
        numPages: 1,
        pdfFile: null,
        loadingFile: false,
        // outPutFormat: "",
        imageHeight: 0,
        tiffImages: [],
        isEditJson: false,
        changedJSON: [],
        isBool: true,
        expandString: false,
        errorList: [],
        errFiles: [],
        healthQueueList: [{
            date: "2020-06-24 07:40:15.406836", description: "test", files: "3",
            project_name: "Health-queue", queue_name: "HC", title: "Health Certificates"
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "test", files: "5",
            project_name: "Health-queue", queue_name: "PO", title: "Purchase Orders "
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "test", files: "2",
            project_name: "Health-queue", queue_name: "INV", title: "Invoices"
        },
        ],
    };

    private deleteFileConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    /** shoe test Image */
    private currPdf: any;
    private tiffImages: any[];
    private imageMap: ImageMap;
    private timeInterval: any;
    public async componentDidMount() {
        this.getProjects();
    }

    public featureStyler = (feature) => {
        const regionId = feature.get("id");
        return new Style({
            stroke: new Stroke({
                color: "#fffc7f",
                width: 1,
            }),
            fill: new Fill({
                color: "rgba(255, 252, 127, 0.2)",
            }),
        });
    }

    public noOp = () => {
        // no operation
    }

    public handleChange = v => {
        let allData = this.state.analyzeResult
        allData[0].dcapResults = v.updated_src[0]
        allData[0].transformationResults = v.updated_src[1]
        this.setState({ changedJSON: allData });
    };

    public errFileShow = () => {
        return (
            <div>
                {this.state.errorList.length > 0 ?
                    <table className="table table-bordered table-dark">
                        <thead>
                            <tr>
                                <th scope="col" className="s-no">#</th>
                                <th scope="col" className="f-name">File name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.errorList.map((file, index) => {
                                const fileName = file.filename;
                                return (
                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{fileName}</td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    : <p className="text-white text-center mt-3">No Data Available</p>
                }
            </div>
        )
    }
    public viewJSONFun = () => {
        if (this.state.analyzeResult && this.state.isEditJson === false) {
            return (
                <div>
                    {this.state.analyzeResult && this.state.isEditJson === false &&
                        <JsonViewer
                            history={this.props.history}
                            match={this.props.match}
                            location={this.props.location}
                            outPutFormat="Transform"
                            export={true}
                            jsonData={this.state.analyzeResult}
                        />
                    }
                </div>
            )
        } else if (this.state.analyzeResult && this.state.isEditJson === true) {
            let transform = this.state.analyzeResult[0].transformationResults
            let dcapResults = [];
            if (transform === undefined) {
                dcapResults.push(this.state.analyzeResult[0].dcapResults)
            } else {
                dcapResults.push(this.state.analyzeResult[0].dcapResults, transform)
            }
            return (
                <div>
                    {/* <h2>Show editable json</h2> */}
                    {this.state.analyzeResult ?
                        <ReactJson theme="bright"
                            iconStyle="square"
                            collapsed={true}
                            onEdit={e => this.handleChange(e)}
                            onDelete={e => this.handleChange(e)}
                            onAdd={e => this.handleChange(e)}
                            src={dcapResults}
                        /> : <div>No Data Available</div>}
                </div>
            )
        }
        else {
            return (
                <div />
            )
        }

    }
    public render() {
      //  const urln= "https://app.powerbi.com/reportEmbed?reportId=2fa227c9-ead2-4d20-bb82-f900b32c3376&appId=54325c90-da8c-4877-9fa2-8b43385820d4&autoAuth=true&ctid=2b6c600f-b6cb-4329-af3b-1b32c62c440f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWluZGlhLXdlc3QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D";
        
      const urln= "https://app.powerbi.com/reportEmbed?reportId=e38a4857-5e5c-4f9e-80c6-d613501ee193&appId=a85fb1fc-64dd-4633-867f-06bf6ba998c7&autoAuth=true&ctid=2b6c600f-b6cb-4329-af3b-1b32c62c440f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWluZGlhLXdlc3QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D";
      return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />


<LoadingOverlay
                   
                  
                >
                    <OperationsHeader propsMatch={this.props.match} />
                 
           

       
              <PowerbiEmbedded
                             
                
              
              
              id="5dc2cdb8-a7a2-42b3-afd9-b36892a24770" 
              
           
           //embedUrl="https://app.powerbi.com/view?r=eyJrIjoiMTIzYTM3OTQtYmNlOS00MDUzLWE2NTgtY2Q4OTUwYTgxNjU2IiwidCI6IjJiNmM2MDBmLWI2Y2ItNDMyOS1hZjNiLTFiMzJjNjJjNDQwZiJ9"
          
           embedUrl="https://app.powerbi.com/view?r=eyJrIjoiMzhlN2FjNzctYTkwZi00YjE2LTkwM2UtMjdhMWVjYzRjZGRiIiwidCI6IjJiNmM2MDBmLWI2Y2ItNDMyOS1hZjNiLTFiMzJjNjJjNDQwZiJ9&pageName=ReportSection7d6948e0da522b2f4abe"
           accessToken="2b6c600f-b6cb-4329-af3b-1b32c62c440f"
            



                filterPaneEnabled={false}
                navContentPaneEnabled={false}
                settings={{
                    // any settings including localeSettings
                }}
                height='100vh'
                />
            
                
</LoadingOverlay>

            </>
        );
    }

    /**
     * Expand
     */
    private getExpandButton = (value) => {
        this.setState({ expandString: value });;
    }
    /**
     * srt Zoom In
     */
    private handleCanvasZoomIn = () => {
        this.imageMap.zoomIn();
    }

    private handleCanvasZoomOut = () => {
        this.imageMap.zoomOut();
    }

    private handleZoomReset = () => {
        this.imageMap.resetZoom();
    }
    /**
     * Get Asset
     */
    private getAssetType = (format) => {
        switch (format.toLowerCase()) {
            case "jpg":
            case "jpeg":
            case "png":
            case "bmp":
                return AssetType.Image;
            case "tif":
            case "tiff":
                return AssetType.TIFF;
            case "pdf":
                return AssetType.PDF;
            default:
                return AssetType.Unknown;
        }
    }
    /**
     * Show Preview
     */
    private loadImage = async (asset) => {
        const lastDot = asset.file_name.lastIndexOf(".");
        const ext = asset.file_name.substring(lastDot + 1);
        const assetType = this.getAssetType(ext)
        if (assetType === AssetType.Image) {
            const canvas = await loadImageToCanvas(asset.path);
            this.setState({
                loadingFile: true,
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
            });
        } else if (assetType === AssetType.TIFF) {
            this.setState({ loadingFile: true });
            await this.loadTiffFile(asset);
        } else if (assetType === AssetType.PDF) {
            this.setState({ loadingFile: true });
            await this.loadPdfFile(asset.path);
        }
    }

    private loadTiffFile = async (asset) => {
        const assetArrayBuffer = await HtmlFileReader.getAssetArray(asset);
        const tiffImages = parseTiffData(assetArrayBuffer);
        this.loadTiffPage(tiffImages, this.state.currentPage);
    }

    private loadTiffPage = (tiffImages: any[], pageNumber: number) => {
        const tiffImage = tiffImages[pageNumber - 1];
        const canvas = renderTiffToCanvas(tiffImage);
        this.setState({
            imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
            imageWidth: tiffImage.width,
            imageHeight: tiffImage.height,
            numPages: tiffImages.length,
            currentPage: pageNumber,
            tiffImages,
        });
    }

    private loadPdfFile = async (url) => {
        try {
            const pdf = await pdfjsLib.getDocument({ url, cMapUrl, cMapPacked: true }).promise;
            // Fetch current page
            if (url) {
                await this.loadPdfPage(url, pdf, this.state.currentPage);
            }
        } catch (reason) {
            // PDF loading error
            console.error(reason);
        }
    }

    private loadPdfPage = async (url, pdf, pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const defaultScale = 2;
        const viewport = page.getViewport({ scale: defaultScale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport,
        };
        await page.render(renderContext).promise;
        if (url) {
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
                numPages: pdf.numPages,
                currentPage: pageNumber,
                pdfFile: pdf
            });
        }
    }


    private showPreview = (file: any) => {
        console.log("****--***-----**--");
    }

    /**
     * Get Projects
     */
    private async getProjects(): Promise<any> {
        this.setState({ loadingProjects: true, loaderMessage: "Loading Models" });
        const { projectName } = this.state;
        const resultData = await this.props.userModelActions.loadUserModels();
        const healthQueue = {
            OCR: "OCR",
            accuracy: 1,
            created_date: "2020-06-24 04:04:17.936572",
            hosted: "Hosted",
            labels: [],
            model_id: "86c1a648-c2f0-49cf-a3d9-122a3e0106e3",
            project_name: "Health-Certificates",
        };
        await this.setState({ projectList: resultData });
        await this.setState((prevState) => ({
            projectList: [...prevState.projectList, healthQueue], loadingProjects: false,
        }));
        if (resultData.length > 0) {
            if (projectName === "Health-queue") {
                this.setState({ projectName: healthQueue.project_name, selectedProject: healthQueue });
            } else {
                const projectValue = resultData.filter((project) => project.project_name === projectName);
                this.setState({ projectName: projectValue[0].project_name, selectedProject: projectValue });
            }
            // if (projectName) {
            //     const projectValue = resultData.filter((project) => project.project_name === projectName);
            //     this.setState({ projectName: projectValue[0].project_name, selectedProject: projectValue[0] });
            //     this.getQueues();
            // }
            // this.setState({ loadingProjects: false, projectList: resultData });
        }
    }

    /**
     * Get Queues
     */

    private async getQueues(): Promise<any> {
        this.setState({ loadingQueues: true, loaderMessage: "Loading Queues" });
        const { projectName, queueName } = this.state;
        const dataEndPoint = await this.props.userOperationsActions.userAllQueues(projectName)
        this.setState({ queuesList: dataEndPoint, loadingQueues: false });
        if (queueName && dataEndPoint.length > 0) {
            const selectedQueue = dataEndPoint.filter((queue) => queue.queue_name === queueName);
            this.setState({ selectedQueue: selectedQueue[0], loadingQueues: false });
            this.getAllFiles();
        } else {
            this.setState({ loadingQueues: false });
        }
    }

    private onChange = async (values) => {
        localStorage.removeItem("queue_name");
        this.setState({ imageUri: null, analyzeResult: null, queueName: "", selectedQueue: null, filesList: [] });
        if (values) {
            await this.setState({ queuesList: [], selectedProject: values, projectName: values.project_name });
            localStorage.setItem("project_name", values.project_name);
            this.getQueues();
        }
    }

    private onQueueChange = async (values) => {
        this.setState({ imageUri: null, analyzeResult: null });
        if (values) {
            await this.setState({ selectedQueue: values, filesList: [], queueName: values.queue_name });
            localStorage.setItem("queue_name", values.queue_name);
            this.getAllFiles();
        }
    }
    /**
     * Get Processed Files
     */
    private getProcessedFiles = () => {
        let headers = accessToken()
        // processedFileEndPoint, LoadUserFilesEndPointBasedOnModel, headers
        const { projectName, queueName } = this.state;
        const endpointURL = processedFileEndPoint(projectName, queueName);
        return ServiceHelper.getWithAutoRetry(endpointURL, { headers });
    }
    /**
     * Get Blob Files
     */
    private getBlobFiles = () => {
        const { projectName, queueName } = this.state;
        const endpointURL = LoadUserFilesEndPointBasedOnModel(projectName, queueName)
        return ServiceHelper.getWithAutoRetry(endpointURL, { headers });
    }
    /**
     * Get All File from both list and process API calls
     */
    private getAllFiles = async () => {
        this.setState({ loadingQueueFiles: true, loadingFile: false, analyzeResult: null, errorList: this.state.errFiles });
        Promise.all([this.getBlobFiles(), this.getProcessedFiles()]).then((values) => {
            const azureData = values[0].data;
            const processedFiles = values[1].data;
            this.mapFilesList(azureData, processedFiles);
        }).catch((err) => {
            this.setState({ loadingQueueFiles: false });
            toast.error("Some thing went wrong.", { position: toast.POSITION.TOP_CENTER });
        });
    }

    /**
     * Map FilesList
     */
    private mapFilesList = (azureData, processedFiles) => {
        const filesList = [];
        if (azureData.length > 0) {
            azureData.filter((data) => {
                const objectData = data;
                const fileName = data.name.split("/");
                const NameOfTheFile = fileName.pop();
                const temp = processedFiles.length > 0 && processedFiles.find((element) => element.file_name === NameOfTheFile);
                if (temp && temp.file_name === NameOfTheFile) {
                    objectData.file_name = temp.file_name;
                    objectData.status = temp.dcapResults && temp.dcapResults.status;
                    objectData.fontIcon = temp.dcapResults && temp.dcapResults.status === "true" ? "fa-check" : "fa-times";
                    objectData.result = temp.result;
                } else {
                    objectData.file_name = NameOfTheFile;
                    objectData.status = null;
                    objectData.result = null;
                }
                filesList.push(objectData);
            });
        }
        this.setState({ loadingQueueFiles: false, filesList });
    }

    private axiosPromise = (URL: string, formData) => {
        let headers = accessToken();
        return axios(URL, { method: "POST", data: formData, headers });
    }

    private getFileNameWithExt(file) {
        const { fileNames, projectName, queueName } = this.state;
        const name = file.name;
        let queueNameString = queueName;
        if (queueNameString.includes(" ")) {
            queueNameString = queueNameString.replace(/ /g, "-");
        }
        if (fileNames.indexOf(name) === -1) {
            const fileData = {};
            fileData["file"] = file;
            fileData["filename"] = name;
            fileNames.push(file["name"]);
            const formData = new FormData();
            formData.append("name", file);
            const URL = fileUploadEndPoint(projectName, file.name, queueName, "na", "na");
            let d = this.axiosPromise(URL, formData).then(data => {
                if (data.data.status != "true" && data.status != 200) {
                    let errObj = {
                        "filename": name
                    }
                    this.state.errFiles.push(errObj)
                }
            }).catch(err => {
                let errObj = {
                    "filename": name
                }
                this.state.errFiles.push(errObj)
            })
            // console.log(this.axiosPromise(URL, formData), "  >>>>this.axiosPromise(URL, formData);")
            return this.axiosPromise(URL, formData);
        } else {
            toast.success(`${file["name"]} file is exists`, { position: toast.POSITION.TOP_CENTER });
        }
    }

    private onChangeHandler = async (event) => {
        event.persist();
        const { queueName } = this.state;
        const tempArray = [];
        let lastFile = false;
        // console.log(event.target.files, " event.target.files")
        if (event.target.files.length > 0) {
            const arrFiles = await Array.from(event.target.files);
            arrFiles.forEach(async (file, index) => {
                tempArray.push(this.getFileNameWithExt(file));
                if (index === arrFiles.length - 1) {
                    return lastFile = true;
                }
            });
        }
        if (lastFile && queueName) {
            this.setState({ loadingQueueFiles: true, loaderMessage: "Uploading Files" });
            Promise.all(tempArray).then((values) => {
                // this.setState({ loadingProjects: false });
                this.getAllFiles();
            }).catch((err) => {
                this.setState({ loadingQueueFiles: false });
                toast.error("Some thing went wrong.", { position: toast.POSITION.TOP_CENTER });
            });
        }
    }

    /**
     * Download JSON export file
     * 
     */

    private downloadFile = async () => {
        const parts = this.state.fileName.split("/");
        const fileName = parts.pop() || parts.pop();
        const nameFile = fileName.replace(/(.*)\.[^.]+$/, "$1");
        const myData = this.state.analyzeResult
        const json = JSON.stringify(myData);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = nameFile + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private editableJSON = () => {
        this.setState({ isEditJson: true })
    }

    private handleSort = () => {
        if (this.state.isBool == false) {
            let sortData = this.state.filesList.sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime());
            this.setState({ filesList: sortData })
        } else {
            let sortData = this.state.filesList.sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime());
            sortData = sortData.reverse()
            this.setState({ filesList: sortData })
        }
    }

    /** Editable JSON View */
    private editableJSONView = () => {
        this.setState({ loadingQueues: true, loaderMessage: "Loading ..." })
        if (this.state.changedJSON[0] != undefined) {
            // this.setState({ loadingJson: true });
            const projectName = this.state.projectName;
            this.props.userOperationsActions.dataRevisionEditJson(this.state.changedJSON[0], projectName).then((editJson) => {
                this.setState({ isEditJson: false, loadingQueues: false, changedJSON: [] });
                toast.success(`success`, { position: toast.POSITION.TOP_CENTER });
            }).catch((err) => {
                toast.error(`Some thing went wrong.`, { position: toast.POSITION.TOP_CENTER });
                this.setState({ isEditJson: false, loadingQueues: false })
                console.log(err);
            });
        } else {
            this.setState({ isEditJson: false, loadingQueues: false })
            toast.warn("There No chnages", { position: toast.POSITION.TOP_CENTER });
        }
    }

    private cancelJsonButtonClick = () => {
        this.setState({ isEditJson: false });
    }

    /**
     * Batch Process Queue
     */
    private processBatch = async () => {

        const { queueName, projectName, selectedProject, selectedQueue } = this.state;
        const processFlagObj = {
            selectedProject,
            selectedQueue,
        }
        localStorage.setItem("processingBatch", JSON.stringify(processFlagObj));
        if (queueName && projectName) {
            this.setState({ batchProcessFlag: true, loaderMessage: "Started batch processing" });
            let queueNameString = queueName;
            if (queueNameString.includes(" ")) {
                queueNameString = queueNameString.replace(/ /g, "-");
            }
            this.props.userOperationsActions.batchPredictionForAllBlobs(projectName, queueName).then((predicteddata) => {
                this.getAllFiles();
                this.setState({ batchProcessFlag: false });
            }).catch((err) => {
                this.setState({ batchProcessFlag: false });
                console.log(err);
            });
        } else {
            toast.warn("Please Select Project/Queue Fields", { position: toast.POSITION.TOP_CENTER });
        }
    }

    /** delete file */
    private deleteAsset = (file: any) => {
        this.deleteFileConfirm.current.open(file);
    }

    private onDeleteFileCancel = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    private onDeleteFile = async (file: any) => {
        this.setState({ loadingQueueFiles: true, loaderMessage: "Deleting  File" });
        const { queueName, projectName } = this.state;
        let str = queueName;
        if (str.includes(" ")) {
            str = queueName.replace(/ /g, "-");
        }
        const resultData = await this.props.userOperationsActions.deleteFileFromQueue(projectName, queueName, file.file_name)
        if (resultData == 'Blobs deleted successfully!') {
            const newArray = [...this.state.filesList];
            const index = await newArray.indexOf(file);
            if (index > -1) {
                newArray.splice(index, 1);
            }
            if (this.state.fileName === file.file_name) {
                this.setState({ loadingFile: false, imageUri: null, analyzeResult: null });
            }
            this.setState({ filesList: newArray, loadingQueueFiles: false });
        } else {
            this.setState({ loadingQueueFiles: false });
            //     console.log(err);
        }
    }

    /** Analyse data from azure */
    private analyseData = async (file: any) => {
        this.setState({ imageUri: null, fileName: file.file_name });
        await this.loadImage(file);
        const { projectName, queueName } = this.state;
        this.setState({ analyzeResult: null, loadingJson: true, errorMessage: null });
        this.props.userOperationsActions.analyseFileJsonResult(projectName, queueName, file.file_name).then((analysedData: any) => {
            if (analysedData.data) {
                this.setState({ analyzeResult: analysedData.data });
            } else if (analysedData.data.error) {
                const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                const errorJson = JSON.parse(data2);
                this.setState({ errorMessage: "The input data is not a valid image or password protected" });
            }
            this.setState({ loadingJson: false });
        }).catch((err) => {
            this.setState({ loadingQueueFiles: false });
        });
    }
}
